module.exports = __webpack_public_path__ + "static/img/third1_2_active.c307dd23.png";